/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import _, { get, isEmpty } from 'lodash';
import {
  Container,
  SahamTabsGlobal,
  StyledTopDiv,
} from 'containers/CourtManagerLegalProceedings/styled-components';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import GlobalLegalProceedingTabs from 'components/GlobalLegalProceedingTabs';
import useCollapse from 'hooks/useCollapse';
import {
  makeSelectCurrentInstanceTab,
  makeSelectCurrentTabManager,
  makeSelectLinkToBeneficiaryCodes,
  makeSelectListings,
  makeSelectGlobalCurrentTabManager,
  makeSelectCurrentTabJudiciaryProcessManager,
  makeSelectNotificationsInboxes,
  makeSelectCurrentTabIndexExpertise,
} from 'containers/AppContainer/selectors';
import { makeSelecClaimRecap } from 'containers/RecapManagerPage/selectors';
import {
  requestAssigment,
  requestClaimRecap,
  requestUpdateVictimInfo,
  requestUpdateBeneficiaryInfo,
  requestUpdateVehicleInfo,
  setClaimRecap,
  requestValidateProvisionIntervenant,
  resetStoreClaim,
} from 'containers/RecapManagerPage/actions';
import {
  requestSearchClaims,
  resetSearchClaimsStore,
} from 'containers/IdentificationPage/actions';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { translate } from 'containers/services/translate';
import {
  makeSelectExpertiseRaport,
  makeSelectJudgementAdd,
  makeSelectJudgementOnMerits,
  makeSelectJudgementAppeal,
  makeSelectDahirAmounts,
  makeSelectDahirAmountsCorpo,
  makeSelectJudgementOnMeritsAppeal,
  makeSelectExpertiseRaportAppeal,
  makeSelectJudgementAddAppeal,
  makeSelectJudgementOnMeritsMultiple,
  makeSelectAppealOnMeritsMultiple,
} from 'containers/LawyerLegalProceedingsPage/selectors';
import {
  requestGetJudgementAdd,
  requestGetDahirAmount,
  requestCreateJudgementOnMeritsContestation,
  requestGetJudgementOnMeritsAppeal,
  requestGetExpertiseReportAppeal,
  requestGetJudgementAddAppeal,
  updateContestation,
  requestUploadContestationDocument,
  requestGetJudgementOnMeritsMultiple,
  requestGetAppealOnMeritsMultiple,
  setLockedClaim,
  resetLegalProceeding,
} from 'containers/LawyerLegalProceedingsPage/actions';
import {
  requestMakeJudgementAddDecision,
  requestValidateExpertReport,
  requestValidateJudgementOnMerits,
  requestValidateJudgementAppeal,
  requestCreateCivilProceeding,
  requestAssignedExpert,
  requestValidateDisclaimerWarranty,
  requestUpdatedCivilProceeding,
  requestValidatedCivilProceeding,
  requestMakeJudgementAddDocumentDecision,
  requestAddVictims,
  requestAddVehicles,
  requestMakeDecisionMissionExpertise,
  requestMakeDecisionMissionNoticeDeficiency,
  requestIsSuspiciosClaim,
  requestCreateJudgementAdd,
  requestLockClaim,
  requestUnlockClaim,
  requestMakeDecisionsDocumentImaging,
  requestGetClaimHistoryActions,
  setDecisionsJudgementIds,
  requestGetClaimHistorySagis,
  requestSetStatusClaimSagis,
  requestResetHistoryStore,
} from 'containers/CourtManagerLegalProceedings/actions';
import {
  IAppealPayload,
  ICurrentSteps,
  IJudgementAdd,
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { getLegalProceedingsSteps } from 'containers/LawyerAssignmentsPage/actions';
import { makeSelectLegalProceedingsSteps } from 'containers/LawyerAssignmentsPage/selectors';
import { requestGetDocByDocumentumId } from 'containers/common/UploadDocument/actions';
import {
  requestGetExpertiseRaport,
  requestGetJudgementOnMerits,
  requestGetJudgementAppeal,
  requestCreateMultipleJudgementAdd,
  requestGetDahirAmountCorpo,
  requestCreateExpertiseRaport,
  requestAddSupportDocument,
  requestCivilPartySupportDocument,
  requestAddExpertiseSupportDocument,
  requestAddJudgementOnMeritsSupportDocument,
} from 'containers/LawyerLegalProceedingsPage/actions';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import ImagineDocumentsDrawer from 'containers/CourtManagerLegalProceedings/ImagineDocuments';
import {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
  requestGetReportsPolicy,
} from 'containers/UploadDocuments/actions';
import {
  requestCreateFeeNote,
  requestUpdateFeeNoteStatus,
  requestUpdateFirmReferenceManager,
  requestUpdateInvoiceFeeNote,
} from 'containers/LawyerFeeNote/actions';
import {
  requestCreateFeeNoteManager,
  requestManagerFeeNotes,
} from 'containers/ManagerFeeNote/actions';
import { requestFeeNoteExceptionalCosts } from 'containers/ManagerFeeNote/actions';
import { requestCorporealLawyers } from 'containers/RecapManagerPage/actions';
import {
  makeSelectDocument,
  makeSelectDocumentId,
} from 'containers/UploadDocuments/selectors';
import {
  makeSelectCountFeeNotes,
  makeSelectFeeNotes,
  makeSelectAllFeeNotes,
} from 'containers/LawyerFeeNote/selectors';
import { makeSelectCivilProceeding } from 'containers/LawyerLegalProceedingsPage/selectors';
import { requestCreateJudgementOnMerits } from 'containers/LawyerLegalProceedingsPage/actions';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { FeeNote } from 'containers/LawyerFeeNote/typings';
import DialogFeeNote from 'components/DialogFeeNote';
import {
  requestFeeNotesByClaimNumb,
  requestAllFeeNotes,
} from 'containers/ManagerFeeNote/actions';
import { makeDecisionFeeNote } from 'containers/ManagerFeeNote/actions';
import { requestGetCivilProceeding } from 'containers/LawyerLegalProceedingsPage/actions';
import {
  requestGetNotificationsInboxes,
  setCurrentInstanceTab,
} from 'containers/AppContainer/actions';
import { makeSelectCorporealLawyers } from 'containers/RecapManagerPage/selectors';
import { requestAddInvoiceFeeNote } from 'containers/LawyerFeeNote/actions';
import {
  requestSagisClaimInfo,
  requestGetJudgementOnMeritsByVictims,
  requestGetJudgementOnMeritsByVehicles,
  requestCreateCorpoEncryptedDocument,
  requestCreateCorporealRegulation,
  requestCreateMaterialRegulation,
  requestCreateAdditionalWarrentiesRegulation,
  requestMaterialEncryptedDocument,
  requestGetAssignedLawyers,
  requestGetRegulations,
  resetSagisInfoClaim,
  requestCreateSummarySheetRegulation,
  uploadDocumentRegulation,
  requestValidateProvision,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import {
  makeSelectSagisClaim,
  makeSelectJudgementOnMeritsByVictims,
  makeSelectJudgementOnMeritsByVehicles,
  makeSelectEncryptedDocuments,
  makeSelectMaterialEncryptedDocuments,
  makeSelectAssignedLawyers,
  makeRegulations,
  makeCreatedRegulations,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/selectors';
import {
  PROVISION_TAB_LABELS,
  REGULATION_TAB_LABELS,
} from 'containers/CourtManagerLegalProceedings/constants';
import {
  claimTabs,
  filterFeeNotes,
} from 'containers/CourtManagerLegalProceedings/utils';
import { TopCard } from 'containers/CourtManagerLegalProceedings/TopCard';
import LegalProceedingTabs from 'components/LegalProceedingTabs';
import ProvisionContainer from 'containers/CourtManagerLegalProceedings/Provision';
import RegulationContainer from 'containers/CourtManagerLegalProceedings/Provision/Regulation';
import { requestGetExpertiseVictim } from 'containers/ExpertExpertise/actions';
import {
  resolveSagisClaim,
  shouldShowVictimExcludedWarning,
} from 'helpers/utils';
import { requestUpdateFeeNoteAmount } from 'containers/LawyerFeeNote/actions';
import RegulationRecapContainer from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RegulationRecapContainer';
import { makeSelectVictimExpertise } from 'containers/ExpertExpertise/selectors';
import { selectedLoader } from 'containers/AppContainer/Loader/selectors';
import SuspiciousCard from 'containers/CourtManagerLegalProceedings/SuspiciousCard';
import { AssignedLawyer } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/typings';
import { requestUpdateClaim } from 'containers/PreOpeningPage/actions';
import {
  makeSelectClaimHistoryActions,
  makeSelectDecisionJudgmentIds,
  makeSelectClaimHistorySagis,
} from 'containers/CourtManagerLegalProceedings/selectors';
import ClaimRecap from 'containers/ConsultationLegalProceedingPage/ClaimRecap';
import TrackingActionDrawer from 'containers/CourtManagerLegalProceedings/TrackingActionDrawer';
import WarningCard from 'containers/common/Card/WarningCard';
import { ClaimRecapType } from 'typings/claimTypes';

export interface ConsultationOpeningPageProps {
  intl: IntlShape;
  listings: Listings;
  storedClaimToPreopen: any;
  requestClaimRecap: Function;
  getLegalProceedingsSteps: Function;
  claimRecap: ClaimRecapType;
  currentSteps: ICurrentSteps[];
  policyInfo: { sagis: { claims: any } };
  requestSearchClaims: Function;
  resetSearchClaimsStore: Function;
  match: { params: { claimId: number } };
  requestGetJudgementAdd: Function;
  judgementAdd: IJudgementAdd;
  requestMakeJudgementAddDecision: Function;
  requestGetExpertiseRaport: Function;
  expertiseReport: ExpertReportType;
  requestValidateExpertReport: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestValidateJudgementOnMerits: Function;
  requestValidateDisclaimerWarranty: Function;
  requestGetJudgementOnMerits: Function;
  judgementOnMerits: JudgementOnMeritsType;
  documentId: string;
  setDocumentId: Function;
  judgementAppeal: IAppealPayload;
  requestGetJudgementAppeal: Function;
  requestValidateJudgementAppeal: Function;
  requestGetDahirAmount: Function;
  dahirAmount: [];
  feeNotes: FeeNote[];
  feeNotesCount: number;
  resetUploadDocumentStore: Function;
  requestManagerFeeNotes: Function;
  requestFeeNotesByClaimNumb: Function;
  requestCreateFeeNote: Function;
  requestFeeNoteExceptionalCosts: Function;
  keyclokToken: string | null;
  makeDecisionFeeNote: Function;
  currentTabInstance: string;
  setCurrentInstanceTab: Function;
  requestAllFeeNotes: Function;
  allFeeNote: FeeNote[];
  requestCorporealLawyers: Function;
  corporealLawyers: any;
  requestCreateCivilProceeding: Function;
  requestGetCivilProceeding: Function;
  judiciaryProcessId: number;
  civilProceeding: [];
  requestCreateJudgementOnMerits: Function;
  requestAssignedExpert: Function;
  requestUpdatedCivilProceeding: Function;
  selectedClaim: any;
  requestSagisClaimInfo: Function;
  sagisClaim: any;
  dahirAmountsCorpo: any;
  requestGetDahirAmountCorpo: Function;
  requestCreateJudgementOnMeritsContestation: any;
  requestGetJudgementOnMeritsAppeal: any;
  judgementOnMeritsAppeal: any;
  expertiseRaportAppeal: any;
  requestGetExpertiseReportAppeal: any;
  requestGetJudgementAddAppeal: Function;
  requestValidatedCivilProceeding: Function;
  judgementAddAppeal: any;
  requestMakeJudgementAddDocumentDecision: Function;
  requestAssigment: Function;
  requestAddVictims: Function;
  linkToBeneficiaryCodes: SagisConfig[];
  updateContestation: Function;
  requestUploadContestationDocument: Function;
  requestUpdateVictimInfo: Function;
  requestUpdateBeneficiaryInfo: Function;
  requestUpdateVehicleInfo: Function;
  setClaimRecap: Function;
  requestAddVehicles: Function;
  requestGetJudgementOnMeritsMultiple: Function;
  requestGetAppealOnMeritsMultiple: Function;
  judgementOnMeritsMultiple: any;
  appealOnMeritsMultiple: any;
  requestGetJudgementOnMeritsByVictims: Function;
  judgementOnMeritsByVictims: any;
  requestGetJudgementOnMeritsByVehicles: Function;
  judgementOnMeritsByVehicles: any;
  requestGetExpertiseVictim: Function;
  requestMakeDecisionMissionExpertise: Function;
  requestMakeDecisionMissionNoticeDeficiency: Function;
  requestCreateCorpoEncryptedDocument: Function;
  requestCreateCorporealRegulation: Function;
  requestCreateMaterialRegulation: Function;
  requestCreateAdditionalWarrentiesRegulation: Function;
  corporealEncryptedDocuments: any;
  requestUpdateFeeNoteAmount: Function;
  expertExpertise: any;
  materialEncryptedDocuments: any;
  requestMaterialEncryptedDocument: Function;
  loaders: any;
  requestIsSuspiciosClaim: Function;
  requestCreateJudgementAdd: Function;
  requestGetAssignedLawyers: Function;
  assignedLawyers: AssignedLawyer[];
  requestCreateMultipleJudgementAdd: Function;
  requestCreateExpertiseRaport: Function;
  requestUpdateClaim?: Function;
  currentIndexTabManager: any;
  currentGlobalTabManagerIndex: any;
  currentInstanceTabIndexManager: any;
  currentJudiciaryProccessId: any;
  requestAddSupportDocument: Function;
  requestCivilPartySupportDocument: Function;
  requestAddExpertiseSupportDocument: Function;
  requestAddJudgementOnMeritsSupportDocument: Function;
  requestValidateProvisionIntervenant: Function;
  requestLockClaim: Function;
  requestUnlockClaim: Function;
  setLockedClaim: any;
  requestGetRegulations: Function;
  regulations: any;
  managerNotifcationsInboxes: any;
  resetStoreClaim: Function;
  resetSagisInfoClaim: Function;
  resetLegalProceeding: Function;
  createdRegulations: any;
  requestCreateSummarySheetRegulation: Function;
  uploadDocumentRegulation: Function;
  requestMakeDecisionsDocumentImaging: Function;
  requestGetNotificationsInboxes: Function;
  requestValidateProvision: Function;
  currentTabManagerExpertise: any;
  requestAddInvoiceFeeNote: Function;
  requestUpdateInvoiceFeeNote: Function;
  decisionJudgementIds: any;
  requestGetClaimHistoryActions: Function;
  userActions: any;
  requestUpdateFeeNoteStatus: Function;
  setDecisionsJudgementIds: Function;
  requestGetClaimHistorySagis: Function;
  claimHistorySagis: any;
  requestSetStatusClaimSagis: Function;
  requestResetHistoryStore: Function;
  requestCreateFeeNoteManager: Function;
  requestGetReportsPolicy: Function;
  requestGetDocByDocumentumId: Function;
  requestUpdateFirmReferenceManager: Function;
}

export const ConsultationOpeningPage: React.FC<ConsultationOpeningPageProps> = (
  props,
): JSX.Element => {
  const [openTrackingDrawer, setOpenTrackingDrawer] = useState(false);

  const [page, setPage] = React.useState<number>(0);

  useEffect(() => {
    return () => {
      props.resetSearchClaimsStore();
      props.resetStoreClaim();
      props.requestResetHistoryStore();
    };
  }, []);

  useEffect(() => {
    return () => {
      props.resetSearchClaimsStore();
      props.resetStoreClaim();
      props.resetSagisInfoClaim();
      props.resetLegalProceeding();
      props.requestResetHistoryStore();
    };
  }, []);
  const [OpenDrawerImagineDocuments, setOpenDraweImagineDocuments] = useState(
    false,
  );

  const handleToggleDrawer = () => {
    setOpenDraweImagineDocuments(!isDrawerOpen);
  };

  const handleToggleTrackingDrawer = () => {
    setOpenTrackingDrawer(!openTrackingDrawer);
  };
  const [isDrawerOpen, setDrawerOpen] = React.useState(false);
  const [expandRow, setExpandRow] = useCollapse(
    get(props.listings, 'managerInboxes', []),
  );

  const claimId = props.match.params.claimId;
  const claimNumber = get(props.claimRecap, 'claim.claimNumber', null);

  const [dropDown, setDropDown] = React.useState<null | HTMLElement>(null);
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false);

  const [currentRegulationTab, setCurrentRegulationTab] = useState(0);

  useEffect(() => {
    const claimId = get(props, ['match', 'params', 'claimId']);
    props.requestGetCivilProceeding(claimId);
  }, [
    claimId,
    props.currentIndexTabManager,
    props.currentGlobalTabManagerIndex,
  ]);

  useEffect(() => {
    const claimId = get(props, ['match', 'params', 'claimId']);
    props.requestClaimRecap(claimId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    claimId,
    claimNumber,
    props.currentIndexTabManager,
    props.currentGlobalTabManagerIndex,
    props.currentJudiciaryProccessId,
  ]);

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };
  useEffect(() => {
    props.requestCorporealLawyers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!_.isEmpty(props.corporealLawyers)]);

  const handleClose = () => {
    setIsDialogOpen(false);
    props.setDecisionsJudgementIds({});
  };

  const tabs = {
    SUMMARY: {
      id: 0,
      title: translate(messages.courtManagerRecapTitle, props),
      feature: true,
    },
    PROVISION_AND_REGULATION: {
      id: 1,
      title: translate(messages.provisionTab, props),
      feature: featureService.hasFeature(FEATURES.PROVISION),
    },
  };
  const [showAddRegulationForm, setShowAddRegulationForm] = React.useState(
    false,
  );
  useEffect(() => {
    if (currentRegulationTab === 0) {
      !isEmpty(claimNumber) && props.requestSagisClaimInfo(claimNumber);
      claimId && props.requestGetRegulations(claimId);
      return setShowAddRegulationForm(false);
    }
  }, [currentRegulationTab]);
  const handleResetStore = () => {
    props.resetSearchClaimsStore();
    props.resetStoreClaim();
    props.resetSagisInfoClaim();
    props.resetLegalProceeding();
    props.requestResetHistoryStore();
  };
  const { currentTabIndex, labels = [] } = {
    currentTabIndex:
      props.currentGlobalTabManagerIndex || claimTabs(tabs)?.currentTabIndex,
    labels: claimTabs(tabs)?.labels,
  };

  return (
    <Container>
      <StyledTopDiv>
        {get(props.claimRecap['claim'], ['suspicious']) &&
          featureService.hasFeature(FEATURES.FRAUDE_CORPO) && (
            <SuspiciousCard />
          )}
        {shouldShowVictimExcludedWarning(
          get(props.claimRecap, 'victims'),
          featureService.hasFeature(FEATURES.IS_VICTIM_EXCLUDED_FROM_COVERAGE),
        ) && (
          <WarningCard
            message={messages.victimExcludedFromCoverageWarningMessage}
          />
        )}
        <TopCard
          claimNumber={get(props.claimRecap['claim'], 'claimNumber', '')}
          claimRecap={props.claimRecap}
          sagisClaim={props.sagisClaim}
          inputProps={{ disableUnderline: true }}
          intl={props.intl}
          setDropDown={setDropDown}
          dropDown={dropDown}
          toggleDrawer={toggleDrawer}
          handleOpenCivilProceeding={() => {}}
          handleOpenDisclaimerWarrantyReasons={() => {}}
          requestSagisClaimInfo={props.requestSagisClaimInfo}
          toggleDrawerAssignmentClaim={() => {}}
          toggleAddVictimCard={() => {}}
          assignedLawyer={get(
            props.claimRecap,
            'claim.assignment[0].assignedLawyer',
          )}
          setIsAssignmentDialogOpen={() => {}}
          setOpenIsSuspiciosClaimDialog={() => {}}
          handleToggleImagineDocDrawer={handleToggleDrawer}
          resetSagisInfoClaim={props.resetSagisInfoClaim}
          claimHasCivilPartyJudiciaryProcess={{}}
          handleToggleTrackingDrawer={handleToggleTrackingDrawer}
          requestSetStatusClaimSagis={props.requestSetStatusClaimSagis}
          isConsultation={true}
          isAllDisabled={
            userPrivileges.userHasPrivilege(PRIVILEGES.ISCONSULTATIONMANAGER) ||
            userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER)
          }
          listings={props.listings}
          handleResetStore={handleResetStore}
        />
      </StyledTopDiv>
      {featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER) && (
        <TrackingActionDrawer
          isDrawerOpen={openTrackingDrawer}
          setIsDrawerOpen={handleToggleTrackingDrawer}
          userActions={props.userActions}
          listings={props.listings}
          claimHistorySagis={props.claimHistorySagis}
          claimNumber={claimNumber}
          claimId={claimId}
          requestGetClaimHistoryActions={props.requestGetClaimHistoryActions}
          requestGetClaimHistorySagis={props.requestGetClaimHistorySagis}
          loaders={props.loaders}
        />
      )}
      {featureService.hasFeature(FEATURES.TRAITEMENT_IMAGINE_DOC) && (
        <ImagineDocumentsDrawer
          isDrawerOpen={OpenDrawerImagineDocuments}
          setIsDrawerOpen={setOpenDraweImagineDocuments}
          listings={props.listings}
          expandRow={expandRow}
          setExpandRow={setExpandRow}
          claimSagisInfo={resolveSagisClaim(props.policyInfo)}
          managerNotifcationsInboxes={props.managerNotifcationsInboxes}
          claimId={claimId}
          requestMakeDecisionsDocumentImaging={
            props.requestMakeDecisionsDocumentImaging
          }
          requestGetNotificationsInboxes={props.requestGetNotificationsInboxes}
          isConsultation={true}
          shouldDisplayUploadDocument={false}
          imagineNotification={{}}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      )}

      {featureService.hasFeature(FEATURES.FEE_NOTE) && (
        <DialogFeeNote
          allFeeNote={props.allFeeNote}
          requestAllFeeNotes={props.requestAllFeeNotes}
          feeNotes={filterFeeNotes(
            props.feeNotes,
            false,
            props.decisionJudgementIds,
            false,
          )}
          feeNotesCount={props.feeNotesCount}
          requestLawyerFeeNotes={props.requestFeeNotesByClaimNumb}
          requestCreateFeeNote={props.requestCreateFeeNote}
          requestFeeNoteCosts={props.requestFeeNoteExceptionalCosts}
          keyclokToken={props.keyclokToken}
          resetUploadDocumentStore={props.resetUploadDocumentStore}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          makeDecisionFeeNote={props.makeDecisionFeeNote}
          open={isDialogOpen}
          handleClose={handleClose}
          showButtonAdd={false}
          title={translate(messages.FeeNoteTitle, props)}
          claimNumber={get(props.claimRecap, 'claim.claimNumber')}
          listings={props.listings}
          page={page}
          setPage={setPage}
          linkToBeneficiaryCodes={props.linkToBeneficiaryCodes}
          isExpert={false}
          requestUpdateFeeNoteAmount={props.requestUpdateFeeNoteAmount}
          loaders={props.loaders}
          requestAddInvoiceFeeNote={props.requestAddInvoiceFeeNote}
          requestUpdateInvoiceFeeNote={props.requestUpdateInvoiceFeeNote}
          requestUpdateFeeNoteStatus={props.requestUpdateFeeNoteStatus}
          contractorFeesSagis={get(props.sagisClaim, 'contractorFees')}
          isManager={false}
          isConsultation={true}
          requestUpdateFirmReferenceManager={
            props.requestUpdateFirmReferenceManager
          }
        />
      )}

      <SahamTabsGlobal>
        <GlobalLegalProceedingTabs
          currentTabIndex={currentTabIndex}
          labels={labels}
          setCurrentInstanceTab={props.setCurrentInstanceTab}
        >
          <ClaimRecap
            listings={props.listings}
            storedClaimToPreopen={props.storedClaimToPreopen}
            requestClaimRecap={props.requestClaimRecap}
            claimRecap={props.claimRecap}
            policyInfo={props.policyInfo}
            requestSearchClaims={props.requestSearchClaims}
            resetSearchClaimsStore={props.resetSearchClaimsStore}
            claimId={claimId as any}
            requestUpdateVictimInfo={props.requestUpdateVictimInfo}
            requestUpdateVehicleInfo={props.requestUpdateVehicleInfo}
            setClaimRecap={props.setClaimRecap}
            requestCreateVehicle={props.requestAddVehicles}
            requestUpdateClaim={props.requestUpdateClaim}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            setDocumentId={props.setDocumentId}
            documentId={props.documentId}
            match={props.match}
            requestRejectClaim={() => {}}
            requestOpenClaim={() => {}}
            requestAssigment={() => {}}
            requestCorporealLawyers={props.requestCorporealLawyers}
            requestOpenMixedClaim={() => {}}
            corporealLawyers={[]}
            openedClaim={undefined}
            requestValidateVehicle={() => {}}
            requestUnlockClaim={() => {}}
            requestLockClaim={() => {}}
            setLockedClaim={() => {}}
            resetStoreClaim={() => {}}
            requestGetReportsPolicy={props.requestGetReportsPolicy}
            requestSagisClaimInfo={props.requestSagisClaimInfo}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
          {get(tabs['PROVISION_AND_REGULATION'], 'feature', false) && (
            <main>
              <LegalProceedingTabs
                labels={PROVISION_TAB_LABELS}
                currentTabIndex={0}
              >
                <ProvisionContainer
                  claimNumber={claimNumber}
                  listings={props.listings}
                  requestSagisClaimInfo={props.requestSagisClaimInfo}
                  sagisClaim={props.sagisClaim}
                  setIsDetail={() => {}}
                  requestValidateProvisionIntervenant={
                    props.requestValidateProvisionIntervenant
                  }
                  claimId={claimId}
                  isConsultation={true}
                  lossDate={get(props.claimRecap, 'claim.lossDate')}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadDocumentStore={props.resetUploadDocumentStore}
                  uploadDocument={props.uploadDocument}
                  requestCreateFeeNoteManager={
                    props.requestCreateFeeNoteManager
                  }
                />
                <LegalProceedingTabs
                  labels={REGULATION_TAB_LABELS}
                  currentTabIndex={currentRegulationTab}
                  setCurrentInstanceTab={setCurrentRegulationTab}
                >
                  <div>
                    <RegulationRecapContainer
                      sagisClaim={props.sagisClaim}
                      listings={props.listings}
                      regulations={props.regulations}
                      isConsultation={true}
                      claimId={claimId}
                    />
                  </div>
                  {showAddRegulationForm && (
                    <RegulationContainer
                      sagisClaim={props.sagisClaim}
                      claimRecap={props.claimRecap}
                      listings={props.listings}
                      judgementOnMeritsByVictims={
                        props.judgementOnMeritsByVictims
                      }
                      requestGetJudgementOnMeritsByVictims={
                        props.requestGetJudgementOnMeritsByVictims
                      }
                      judgementOnMeritsByVehicles={
                        props.judgementOnMeritsByVehicles
                      }
                      requestGetJudgementOnMeritsByVehicles={
                        props.requestGetJudgementOnMeritsByVehicles
                      }
                      requestCreateCorpoEncryptedDocument={
                        props.requestCreateCorpoEncryptedDocument
                      }
                      corporealEncryptedDocuments={
                        props.corporealEncryptedDocuments
                      }
                      requestCreateCorporealRegulation={
                        props.requestCreateCorporealRegulation
                      }
                      requestCreateMaterialRegulation={
                        props.requestCreateMaterialRegulation
                      }
                      requestCreateAdditionalWarrentiesRegulation={
                        props.requestCreateAdditionalWarrentiesRegulation
                      }
                      requestMaterialEncryptedDocument={
                        props.requestMaterialEncryptedDocument
                      }
                      materialEncryptedDocuments={
                        props.materialEncryptedDocuments
                      }
                      requestGetAssignedLawyers={
                        props.requestGetAssignedLawyers
                      }
                      assignedLawyers={props.assignedLawyers}
                      requestSagisClaimInfo={props.requestSagisClaimInfo}
                      requestGetDahirAmount={props.requestGetDahirAmount}
                      requestGetDahirAmountCorpo={
                        props.requestGetDahirAmountCorpo
                      }
                      dahirAmountsCorpo={props.dahirAmountsCorpo}
                      dahirAmount={props.dahirAmount}
                      uploadDocument={props.uploadDocument}
                      resetUploadDocumentStore={props.resetUploadDocumentStore}
                      uploadedDocument={props.uploadedDocument}
                      requestValidateProvisionIntervenant={
                        props.requestValidateProvisionIntervenant
                      }
                      createdRegulations={props.createdRegulations}
                      requestCreateSummarySheetRegulation={
                        props.requestCreateSummarySheetRegulation
                      }
                      uploadDocumentRegulation={props.uploadDocumentRegulation}
                      corpoRegulations={props.regulations}
                      policyInfo={props.policyInfo}
                      requestValidateProvision={props.requestValidateProvision}
                    />
                  )}
                </LegalProceedingTabs>
              </LegalProceedingTabs>
            </main>
          )}
        </GlobalLegalProceedingTabs>
      </SahamTabsGlobal>
    </Container>
  );
};

const mapDispatchToProps = {
  requestUpdateVictimInfo,
  requestClaimRecap,
  requestSearchClaims,
  getLegalProceedingsSteps,
  resetSearchClaimsStore,
  requestGetJudgementAdd,
  requestMakeJudgementAddDecision,
  requestGetExpertiseRaport,
  requestValidateExpertReport,
  requestValidateJudgementOnMerits,
  requestGetJudgementOnMerits,
  requestGetJudgementOnMeritsAppeal,
  requestGetExpertiseReportAppeal,
  uploadDocument,
  resetUploadDocumentStore,
  requestGetJudgementAppeal,
  requestValidateJudgementAppeal,
  requestGetDahirAmount,
  setDocumentId,
  requestManagerFeeNotes,
  requestCreateFeeNote,
  requestFeeNoteExceptionalCosts,
  requestFeeNotesByClaimNumb,
  makeDecisionFeeNote,
  setCurrentInstanceTab,
  requestAllFeeNotes,
  requestCorporealLawyers,
  requestCreateCivilProceeding,
  requestGetCivilProceeding,
  requestGetJudgementAddAppeal,
  requestCreateJudgementOnMerits,
  requestAssignedExpert,
  requestValidateDisclaimerWarranty,
  requestUpdatedCivilProceeding,
  requestValidatedCivilProceeding,
  requestSagisClaimInfo,
  requestGetDahirAmountCorpo,
  requestCreateJudgementOnMeritsContestation,
  requestMakeJudgementAddDocumentDecision,
  requestAssigment,
  requestAddVictims,
  updateContestation,
  requestUploadContestationDocument,
  requestUpdateBeneficiaryInfo,
  requestUpdateVehicleInfo,
  setClaimRecap,
  requestAddVehicles,
  requestGetAppealOnMeritsMultiple,
  requestGetJudgementOnMeritsMultiple,
  requestGetJudgementOnMeritsByVictims,
  requestGetJudgementOnMeritsByVehicles,
  requestGetExpertiseVictim,
  requestMakeDecisionMissionExpertise,
  requestMakeDecisionMissionNoticeDeficiency,
  requestCreateCorpoEncryptedDocument,
  requestCreateCorporealRegulation,
  requestCreateMaterialRegulation,
  requestCreateAdditionalWarrentiesRegulation,
  requestUpdateFeeNoteAmount,
  requestMaterialEncryptedDocument,
  requestIsSuspiciosClaim,
  requestCreateJudgementAdd,
  requestGetAssignedLawyers,
  requestCreateMultipleJudgementAdd,
  requestCreateExpertiseRaport,
  requestUpdateClaim,
  requestAddSupportDocument,
  requestCivilPartySupportDocument,
  requestAddExpertiseSupportDocument,
  requestAddJudgementOnMeritsSupportDocument,
  requestValidateProvisionIntervenant,
  requestLockClaim,
  requestUnlockClaim,
  setLockedClaim,
  requestGetRegulations,
  resetStoreClaim,
  resetSagisInfoClaim,
  resetLegalProceeding,
  requestCreateSummarySheetRegulation,
  uploadDocumentRegulation,
  requestMakeDecisionsDocumentImaging,
  requestGetNotificationsInboxes,
  requestAddInvoiceFeeNote,
  requestValidateProvision,
  requestUpdateInvoiceFeeNote,
  requestGetClaimHistoryActions,
  requestUpdateFeeNoteStatus,
  setDecisionsJudgementIds,
  requestGetClaimHistorySagis,
  requestSetStatusClaimSagis,
  requestResetHistoryStore,
  requestCreateFeeNoteManager,
  requestGetReportsPolicy,
  requestGetDocByDocumentumId,
  requestUpdateFirmReferenceManager,
};

const mapStateToProps = createStructuredSelector({
  listings: makeSelectListings(),
  claimRecap: makeSelecClaimRecap(),
  policyInfo: makeSelectSearchClaims(),
  uploadedDocument: makeSelectDocument(),
  judgementAdd: makeSelectJudgementAdd(),
  currentSteps: makeSelectLegalProceedingsSteps(),
  expertiseReport: makeSelectExpertiseRaport(),
  judgementAddAppeal: makeSelectJudgementAddAppeal(),
  expertiseRaportAppeal: makeSelectExpertiseRaportAppeal(),
  judgementOnMerits: makeSelectJudgementOnMerits(),
  judgementOnMeritsAppeal: makeSelectJudgementOnMeritsAppeal(),
  judgementAppeal: makeSelectJudgementAppeal(),
  dahirAmount: makeSelectDahirAmounts(),
  documentId: makeSelectDocumentId(),
  feeNotes: makeSelectFeeNotes(),
  feeNotesCount: makeSelectCountFeeNotes(),
  keyclokToken: makeSelectKeycloakToken(),
  currentTabInstance: makeSelectCurrentInstanceTab(),
  allFeeNote: makeSelectAllFeeNotes(),
  corporealLawyers: makeSelectCorporealLawyers(),
  civilProceeding: makeSelectCivilProceeding(),
  sagisClaim: makeSelectSagisClaim(),
  dahirAmountsCorpo: makeSelectDahirAmountsCorpo(),
  linkToBeneficiaryCodes: makeSelectLinkToBeneficiaryCodes(),
  judgementOnMeritsMultiple: makeSelectJudgementOnMeritsMultiple(),
  appealOnMeritsMultiple: makeSelectAppealOnMeritsMultiple(),
  judgementOnMeritsByVictims: makeSelectJudgementOnMeritsByVictims(),
  judgementOnMeritsByVehicles: makeSelectJudgementOnMeritsByVehicles(),
  corporealEncryptedDocuments: makeSelectEncryptedDocuments(),
  materialEncryptedDocuments: makeSelectMaterialEncryptedDocuments(),
  expertExpertise: makeSelectVictimExpertise(),
  loaders: selectedLoader,
  assignedLawyers: makeSelectAssignedLawyers(),
  currentIndexTabManager: makeSelectCurrentTabManager(),
  currentGlobalTabManagerIndex: makeSelectGlobalCurrentTabManager(),
  currentJudiciaryProccessId: makeSelectCurrentTabJudiciaryProcessManager(),
  regulations: makeRegulations(),
  createdRegulations: makeCreatedRegulations(),
  managerNotifcationsInboxes: makeSelectNotificationsInboxes(),
  currentTabManagerExpertise: makeSelectCurrentTabIndexExpertise(),
  decisionJudgementIds: makeSelectDecisionJudgmentIds(),
  claimHistoryActions: makeSelectClaimHistoryActions(),
  userActions: makeSelectClaimHistoryActions(),
  claimHistorySagis: makeSelectClaimHistorySagis(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ConsultationOpeningPage));
